'use es6';

import { List } from 'immutable';
import { Promise } from '../../lib/promise';
import { SUM } from '../../constants/metricTypes';
const METRIC_TYPES = List.of(SUM);
export const configure = config => Promise.resolve(config.has('metrics') ? config.update('metrics', (metrics = List()) => metrics.map(metric => metric.get('metricTypes', List()).isEmpty() ? metric.set('metricTypes', METRIC_TYPES) : metric)) : config);